import { useEffect, useState, useCallback } from "react";
import { Urls } from "../../../../Urls";
import axios from "../../../../Axios/Axios";

export const useFetchTruckLocation = (indent_id, indent_id_sub) => {
  const [trackData, setTrackData] = useState(null);
  const [err, setErr] = useState(null);
  const [loadingTruckLocation, setLoadingTruckLocation] = useState(false); // loading for truck location
  const [loadingIndentDetails, setLoadingIndentDetails] = useState(false);  // loading for indentdetails
  const [indentDetails, setIndentDetails] = useState(null);
  const [globalErr, setGlobalErr] = useState(null) //display error in entire page

  const fetchIndentDetails = async () => {
    setLoadingIndentDetails(true);
    try {
      const resp = await axios.get(`${Urls.invoice_tpmp}?field=consignment&indent_id=${indent_id}&indent_id_sub=${indent_id_sub}`);
      if (resp?.data && resp?.data[0]) {
        setIndentDetails(resp?.data[0]);
      }
    } catch (error) {
      setIndentDetails(null);
      console.log(error, "Error");
    } finally {
      setLoadingIndentDetails(false);
    }
  };

  const fetchTruckLocation = useCallback(async () => {
    if (!indent_id || !indent_id_sub) {
      setGlobalErr("Invalid Indent Details");
      setTrackData(null);
      return;
    }

    setLoadingTruckLocation(true);
    setErr(null);
    setGlobalErr(null)
    try {
      const uri = `${Urls.indentTrackAndTrace}?field=get_fastag_live_location&indent_id=${indent_id}&indent_id_sub=${indent_id_sub}`

      const { data } = await axios.get(uri);

      // handle internal errors
      if (data && data?.status === false) {
        if (data?.error === "unauthorized") {
          // un-authorized
          setIndentDetails(null)
          setTrackData(null);
          setGlobalErr(data?.message || "Something went wrong. Please try again later")
          return;
        } else {

          if (data?.message === "No valid track_id found") {
            setTrackData(data);
            return;
          }

          console.log("Internal Error : ", data?.status)
          setErr(data?.message || "Something went wrong. Please try again later.");
          return;
        }
      }

      // handle ulip API errors
      if (data?.["truck_location_details"] && data?.["truck_location_details"]?.status === false) {
        console.log("ULIP Error :", data?.["truck_location_details"]?.error)
        setErr(data?.["truck_location_details"]?.error || "Something went wrong. Please try again later.");
        setTrackData(data);
        return;
      } else {
        setTrackData(data);
        setErr(null);
        setGlobalErr(null)
      }
    } catch (error) {
      console.error("Failed to fetch truck location:", error);
      setErr("Something went wrong. Please try again later.");
      setTrackData(null);
    } finally {
      setLoadingTruckLocation(false);
    }
  }, [indent_id_sub, indent_id]);

  useEffect(() => {
    if (indent_id && indent_id_sub) {
      fetchIndentDetails();
    }
  }, [indent_id_sub, indent_id]);

  useEffect(() => {
    fetchTruckLocation();
  }, [fetchTruckLocation]);

  return { fetchTruckLocation, trackData, loadingTruckLocation, loadingIndentDetails, err, indentDetails, fetchIndentDetails, globalErr };
};
